import React, { useMemo } from 'react';

export default function ContinuePage({ files, onRun }) {
  const status = useMemo(() => {
    const paths = Array.from(files || []).map(f => f.webkitRelativePath || f.name);
    const contains = (pattern) => paths.some(p => p.includes(pattern));
    return {
      graph: contains('data/graph.pickle'),
      lv: contains('data/lv_grids'),
      mv: contains('data/mv_grids'),
    };
  }, [files]);

  const bothGrids = status.lv && status.mv;

  return (
    <div className="continue-container">
      <h2>Complete Grid Generation</h2>
      <p className="continue-hint">
        Continues whatever is missing (LV, MV, or both) from the uploaded folder
        and rebuilds the map tiles. Requires the general graph (data/graph.pickle).
      </p>
      <button
        className="intro-button"
        disabled={!status.graph}
        onClick={() => onRun?.('auto')}
      >
        {bothGrids ? 'Update maps' : 'Continue generation'}
      </button>
    </div>
  );
}
